import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@app/layout/main-layout/main-layout.component';
import { UserListResolverService } from '@app/resolvers/user-list-resolver.service';
import { CustomReuseStrategy } from '@app/shared/common/routeReusedStrategy';
import { ReuseStrategyEnum } from '@app/shared/enum/reuseStrategy.enum';
import { PageNotFoundComponent } from '@app/pages/page-not-found/page-not-found.component';
import { CorpPrefixResolverService, WebviewMenuResolverService } from '@app/webview/webview-menu-resolver.service';
import { ScrollPositionService } from '@app/shared/scroll.service';
import { RouteCondition, RouteOutlet } from '@app/shared/enum/route';
import { RecordListNavigateComponent } from '@app/record/record-based/record-list-based.component';
import { RecordDetailComponent } from '@app/record/record-detail/record-detail.component';
import { RecordDetailResolverService } from '@app/record/record-detail-resolver.service';
import { CareconneResolverService } from '@app/resolvers/careconne.resolver';
import { CareconneRoomResolver } from '@app/resolvers/careconne-room.resolver';
import { SlideUpWindowComponent } from '@app/components/slide-up-window/slide-up-window.component';
import { SlideUpWindowByStudentComponent } from '@app/components/slide-up-window-by-student/slide-up-window-by-student.component';
import { CareconneRoomByStudentResolver } from '@app/resolvers/careconne-room-by-student.resolver';

// const isDev = sessionStorage.getItem('dev') == '1';
const routeChildren: Routes = [
  // {
  //   path: 'list-user',
  //   component: RecordListNavigateComponent,
  //   resolve: {
  //     userList: UserListResolverService,
  //   },
  //   data: {
  //     routeCongfig: RouteCondition.LIST,
  //     reuseKey: ReuseStrategyEnum.REUSED,
  //     reuseRoute: ['detail/:noteid'],
  //   }
  // },
  {
    path: 'list',
    component: RecordListNavigateComponent,
    data: {
      routeCongfig: RouteCondition.LIST,
      reuseKey: ReuseStrategyEnum.REUSED,
      reuseRoute: ['detail/:noteid'],
    },
  },
  // {
  //   path: 'list-shienkeika',
  //   component: RecordShienkeikaComponent,
  //   resolve: {
  //     userList: UserListResolverService,
  //   },
  //   data: {
  //     routeCongfig: RouteCondition.LIST,
  //     reuseKey: ReuseStrategyEnum.REUSED,
  //     reuseRoute: ['detail/:noteid'],
  //   },
  // },
  {
    path: 'detail/:noteid',
    component: RecordDetailComponent,
    resolve: { record: RecordDetailResolverService },
  },
  {
    path: 'test',
    component: RecordListNavigateComponent,
  },
  // {
  //   path: 'facesheet',
  //   component: FacesheetComponent,
  //   data: { facesheet: true },
  //   resolve: {
  //     params: FacesheetParamResolver
  //   }
  // },
  // {
  //   path: 'casefile',
  //   component: CasefileComponent,
  //   resolve: {
  //     params: CasefileParamResolver
  //   },
  //   data: {
  //     routeCongfig: RouteCondition.LIST,
  //     reuseKey: ReuseStrategyEnum.REUSED,
  //     reuseRoute: ['detail/:noteid'],
  //   },
  // },

  { path: '**', component: PageNotFoundComponent },
];
const routeOutlets: Routes = [
  // {
  //   path: 'user-selector-facesheet',
  //   component: UserSelectOutletFacesheetComponent,
  //   resolve: {
  //     userList: UserListResolverService,
  //     userInGroup: UserInGroupResolverService,
  //   },
  //   outlet: RouteOutlet.EDIT,
  // },
  // {
  //   path: 'user-selector-record',
  //   component: UserSelectOutletFacesheetComponent,
  //   resolve: {
  //     userList: UserListResolverService,
  //     userInGroup: UserInGroupResolverService,
  //   },
  //   outlet: RouteOutlet.EDIT,
  // },
  {
    path: 'careconne-rooms',
    component: SlideUpWindowComponent,
    resolve: {
      rooms: CareconneRoomResolver
    },
    outlet: RouteOutlet.MODAL,
  },
  {
    path: 'careconne-rooms-by-student',
    component: SlideUpWindowByStudentComponent,
    resolve: {
      roomsByStudent: CareconneRoomByStudentResolver
    },
    outlet: RouteOutlet.MODAL,
  },
  // {
  //   path: 'user-selector-casefile',
  //   component: UserSelectOutletCasefileComponent,
  //   resolve: {
  //     userList: UserListResolverService,
  //     userInGroup: UserInGroupResolverService,
  //   },
  //   outlet: RouteOutlet.EDIT,
  // },
];
// const routeDevMode: Routes = isDev ?
//   [{
//     path: 'menu',
//     component: MenuComponent,
//     outlet: 'modal',
//   }] : [];


const routes: Routes = [
  {
    path: 'home',
    component: MainLayoutComponent,
    resolve: {
      corpPrefix: CorpPrefixResolverService,
      menuList: WebviewMenuResolverService,
      userList: UserListResolverService,
      isCareConneUser: CareconneResolverService
    },
    children: [
      ...routeChildren,

    ]
  },
  ...routeOutlets,
  // ...routeDevMode
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: RouteReuseStrategy,
      useFactory: (scrollService: ScrollPositionService) => new CustomReuseStrategy(scrollService),
      deps: [ScrollPositionService],
    }
  ]
})
export class HomeRoutingModule { }
